export default Object.freeze({
    TITLE_INSURANCE_APPLICATION: 7,
    FILE: 10,
    DEED: 11,
    ADDITIONAL: 12,
    REVIEW: 13
});